// cmsNoEditor is the minimal stand-in for the cmsEditor() Alpine component on
// CMS pages that render the target switcher but have NOTHING editable (the
// area-guide empty state). The switcher's click handler
// (components.cmsTargetClickHandler) calls _blockOnInvalidPlaceholders() and
// flushPending() — cmsEditor methods that, without an enclosing scope, throw
// "not defined" and the switch never navigates. This provides exactly those two
// with the "no editor, nothing to save" answers. Keep in sync with the contract
// the switcher relies on; the real implementations live in editor.ts.
export function cmsNoEditor() {
  return {
    _blockOnInvalidPlaceholders(): boolean {
      return false;
    },
    flushPending(): Promise<boolean> {
      return Promise.resolve(true);
    },
  };
}
